import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { GridApi, ColDef, GridOptions, ValueFormatterParams, CellClassParams, RowClassParams } from 'ag-grid-enterprise';

// CSS
import './NotificationsGrid.css';
// import 'ag-grid-enterprise/styles/ag-grid.css';
// import 'ag-grid-enterprise/styles/ag-theme-balham.css';

interface GridProps {
  onGridReadyParent: (params: { api: any }) => void;
}

const Grid: React.FC<GridProps> = ({onGridReadyParent}) => {

  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  // グリッドの初期化
  const onGridReady = (params: { api: GridApi }) => {
    setGridApi(params.api);
    onGridReadyParent(params);
  }

  // 行のCSSクラスの設定
  const rowClassRules = {
    'notifications-row-add': (params: RowClassParams) => {
      return params.data.is_add === true
    },
  }
  
  const columns: ColDef[] = [
    { headerName: '注文No', field: 'po_data_num', minWidth:150, maxWidth:150,},
    { headerName: '受注No', field: 'po_desc_num', minWidth:150, maxWidth:150,},
    { headerName: '得意先名', field: 'customer_name', minWidth:230, maxWidth:230, },
    { headerName: '送り先名', field: 'destin_name', minWidth:230, maxWidth:230, },
    { headerName: '変更件名', field: 'message.title', minWidth:230, maxWidth:230, },
    { headerName: '変更詳細', field: 'message.body' , },
  ];

  const defaultColDef = {
    resizable: true,
    floatingFilter: false,
    sortable: false,
    enableMenu:false,
    enableSorting: false,
    enableFilter: false,
    pinSubMenu:false,
    rowSelection:'single',
  };

  // コンポーネントのロジック
  const gridOptions: GridOptions = {
    defaultColDef: defaultColDef,
    columnDefs: columns,
    rowClassRules: rowClassRules,
    rowHeight:35,
    //
    getRowId: (params) => {
      return params.data.id;
    }
  };

  return (
    // 描画するReact要素
    <div className="ag-theme-balham">
      <AgGridReact
        {...gridOptions}
        //rowData={rowData}
        domLayout={"normal"}  // テーブルの高さを自動調整
        onGridReady={onGridReady}
      />
    </div>
  );
};

export default Grid;